//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {

  'use strict';

  var $target = $('.subpages__widgets');
  var offset;

  if ($target.length > 0) {
    $(window).on('resize', function (ev) {
      ev.preventDefault();

      setTimeout(function() {
        offset = $target.offset().left;
        $target = $target.css('left', -(offset));
      }, 300);
    }).resize();
  }
})();
